export const HandleError = (props: any, error: Error, detailedError?: string) => {
    if (error.message === "TokenExpired") {
        localStorage.setItem('authenticated', 'false');
    }
    else {
        props.setToast({
            isVisible: true,
            message: {
                details: detailedError?.length !== 0 ? detailedError + " : " + error.message : error.message,
                heading: "Error",
            },
            variant: "error"
        });
        console.error("Error fetching data:", error.message);
    }
}

export const isValidUrl = (str: string): { isValid: boolean; errorMessage: string } => {
    if (!str || str.length === 0) {
        return { isValid: true, errorMessage: "" };
    }
    try {
        new URL(str);
        return { isValid: true, errorMessage: "" };
    } catch (_) {
        return { isValid: false, errorMessage: "Please enter a valid URL" };
    }
};